export default "__VITE_ASSET__BLm9GHIc__"